import * as React from "react";
const SvgFiRrAirplaneJourney = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#fi-rr-airplane-journey_svg__a)">
      <path
        fill="#062147"
        d="M17.26 10.292c.48.469 1.11.704 1.74.704s1.26-.235 1.74-.704l1.795-1.756a5.005 5.005 0 0 0 0-7.071A4.97 4.97 0 0 0 19 .001c-1.335 0-2.591.52-3.536 1.464a5.01 5.01 0 0 0 .008 7.079zm-.381-7.413A2.98 2.98 0 0 1 19 2a3 3 0 0 1 2.129 5.113l-1.788 1.748a.484.484 0 0 1-.683 0l-1.78-1.74a3.004 3.004 0 0 1 0-4.242M24 17c0 2.206-1.794 4-4 4h-7a1 1 0 0 1 0-2h7c1.103 0 2-.897 2-2s-.897-2-2-2H9c-2.206 0-4-1.794-4-4s1.794-4 4-4h3a1 1 0 0 1 0 2H9c-1.103 0-2 .897-2 2s.897 2 2 2h11c2.206 0 4 1.794 4 4m-14 3a1 1 0 0 1-1 1H7.5L5.59 23.421a1.11 1.11 0 0 1-.975.579h-.32a.543.543 0 0 1-.506-.74L4.668 21h-2.32a1.5 1.5 0 0 1-1.147-.533l-1.096-1.3a.78.78 0 0 1 1.228-.939l1.11.772h2.24l-.89-2.258A.543.543 0 0 1 4.298 16h.298c.407 0 .78.222.975.579L7.5 19H9a1 1 0 0 1 1 1M20 4.787a1 1 0 1 1-2 0 1 1 0 0 1 2 0"
      />
    </g>
    <defs>
      <clipPath id="fi-rr-airplane-journey_svg__a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgFiRrAirplaneJourney;
